import request from './adminRequest'

export const libaPreviewApi = {
  listLibaPreview (params) {
    return request.get('/libaPreviews', { params: params })
  },
  getLibaPreview (id) {
    return request.get('/libaPreviews/' + id)
  },
  saveLibaPreview (data) {
    return request.post('/libaPreviews', data)
  },
  updateLibaPreview (id, data) {
    return request.put('/libaPreviews/' + id, data)
  },
  deleteLibaPreview (id) {
    return request.delete('/libaPreviews/' + id)
  },

}
export default libaPreviewApi
